import React, { useState } from 'react';
import { Typography, Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { mavlink20 } from '../../mavlink/mavlink20Wrapper';

const AltFrameTypes = {
    [mavlink20.MAV_FRAME_GLOBAL]:  'GLOBAL',
    [mavlink20.MAV_FRAME_GLOBAL_RELATIVE_ALT_INT]:  'GLOBAL_RELATIVE_ALT_INT', 
    [mavlink20.MAV_FRAME_GLOBAL_TERRAIN_ALT_INT]: 'GLOBAL_TERRAIN_ALT_INT'
};

const getDialogTitle = (cmd) => {
    switch (cmd) {
        case 'go_to':
            return "Go To Selected Location" 
        case 'set_roi':
            return 'Set ROI Location';
        case 'set_home':
            return 'Set Home Location';  
        default:
            return 'Unknown Command';
    }
};

const getDialogDefaultAltitude = (cmd) => {
    switch (cmd) {
        case 'go_to':
            return 100;
        case 'set_roi':
            return 0;
        case 'set_home':
            return 0;
        default:
            return 0;
    }
};

const getDialogDefaultFrame = (cmd) => {
    switch (cmd) {
        case 'go_to':
            return mavlink20.MAV_FRAME_GLOBAL_RELATIVE_ALT_INT;
        case 'set_roi':
            return mavlink20.MAV_FRAME_GLOBAL_RELATIVE_ALT_INT;
        case 'set_home':
            return mavlink20.MAV_FRAME_GLOBAL_RELATIVE_ALT_INT;
        default:
            return mavlink20.MAV_FRAME_GLOBAL_RELATIVE_ALT_INT;
    }
};

const handleDialogSubmit = (cmd, selectedMavId, lat, lon, alt, frame) => {
    switch (cmd) {
        case 'go_to':
            window.api.goTo(selectedMavId, lat, lon, alt, frame);
            break;
        case 'set_roi':
            window.api.setRoi(selectedMavId, lat, lon, alt, frame);
            break;
        case 'set_home':
            window.api.setHome(selectedMavId, lat, lon, alt, frame);
            break;
        default:
            console.error('Unknown command:', cmd);
    }
};

const SetPositionDialog = ({ open, onClose, selectedMavId, mapSelectedLocation, cmd}) => {
    const [altitude, setAltitude] = useState(getDialogDefaultAltitude(cmd));
    const [altFrameType, setAltFrameType] = useState(getDialogDefaultFrame(cmd)); ;
    const handleSubmit = () => {
        const lat = mapSelectedLocation[0];
        const lon = mapSelectedLocation[1];
        const alt = altitude;
        const frame = altFrameType;
        handleDialogSubmit(cmd, selectedMavId, lat, lon, alt, frame);
        onClose();
    };
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: '400px',
                    margin: 'auto',
                },
            }}
        >
            <DialogTitle>{getDialogTitle(cmd)}</DialogTitle>
            <DialogContent>
                <FormControl fullWidth margin="dense" size="small">
                    <InputLabel>Frame Type</InputLabel>
                    <Select
                        value={altFrameType}
                        onChange={(e) => setAltFrameType(e.target.value)}
                        label="ALt Frame Type"
                    >
                        {Object.entries(AltFrameTypes).map(([key, value]) => (
                            <MenuItem key={key} value={key}>
                                {value}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Altitude (m)"
                    type="number"
                    value={altitude}
                    size="small"
                    onChange={(e) => setAltitude(e.target.value)}
                />
                <Typography>Latitude: {mapSelectedLocation[0]}</Typography>
                <Typography>Longitude: {mapSelectedLocation[1]}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} size="small">Cancel</Button>
                <Button onClick={handleSubmit} size="small">Submit</Button>
            </DialogActions>
        </Dialog>
    );
};

export default SetPositionDialog;